import { render } from "./sales-resource-update.vue?vue&type=template&id=26cfc827"
import script from "./sales-resource-update.vue?vue&type=script&lang=js"
export * from "./sales-resource-update.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__